module.exports = __webpack_public_path__ + "img/toolbox.e1d5d85e.svg";